import { render, staticRenderFns } from "./VenueInfo.vue?vue&type=template&id=32678ba2&"
import script from "./VenueInfo.vue?vue&type=script&lang=js&"
export * from "./VenueInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports